/* AMYO Accessibility cart-status helper (draft-only).
   3B  - ATC SUCCESS: a single document-level variant:add subscriber announces the
         localized "added to cart" string once in a polite live region.
   4a-4 - ATC ERROR de-dupe: a failed add makes the native theme prepend a
         role="alert" .banner--error to BOTH the main and the sticky <buy-buttons>
         (each binds the same form) -> two visible banners + two role=alert nodes.
         This INTENTIONALLY changes the visible UX: it keeps the single banner in
         the <buy-buttons> the shopper actually submitted from and removes the
         duplicate synchronously -> one final visible banner + one final role=alert
         in AT-proxy/final-DOM (real screen-reader single-announce pending QA).
   Scope: the ATC POST, cart drawer, the surviving native banner's markup/role/
   auto-remove, buy-buttons, sticky bar, schema, and hrefs are unchanged. */
(function () {
  if (window.__amyoCartStatusInit) return;          // single init even if double-included
  window.__amyoCartStatusInit = true;

  function announce(msg) {
    var r = document.querySelector('[data-a11y-cart-status]');
    if (!r || !msg) return;
    r.textContent = '';                               // clear first so repeat adds re-announce
    setTimeout(function () { r.textContent = msg; }, 50);
  }

  document.addEventListener('variant:add', function () {
    var s = window.themeVariables && window.themeVariables.settings;
    if (s && s.cartType === 'message') return;        // native banner already announces in that mode
    var str = (window.themeVariables && window.themeVariables.strings
               && window.themeVariables.strings.addedToCart) || 'Added to cart';
    announce(str);
  });

  // 4a-4: remember which <buy-buttons> the shopper submitted from, so the surviving
  // error banner sits next to the control they actually used (main vs sticky bar).
  var lastSubmitBuyButtons = null;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || String(form.action).indexOf('/cart/add') === -1) return;
    lastSubmitBuyButtons = (e.submitter && e.submitter.closest)
      ? e.submitter.closest('buy-buttons') : null;
  }, true);                                           // capture: record before the add resolves

  // 4a-4: collapse the native double error banner to one. Native onCartError (theme.js)
  // prepends a role="alert" .banner--error to every <buy-buttons> bound to the errored form.
  // This runs in the bubble phase of the SAME cart:error dispatch (after the native
  // target-phase listeners), so both banners already exist; removing the duplicate here is
  // synchronous -> one final visible banner + one final role=alert in AT-proxy/final-DOM
  // (real-SR single-announce pending).
  document.addEventListener('cart:error', function (e) {
    var form = e.target;
    var formId = (form && form.getAttribute) ? form.getAttribute('id') : null;
    var groups = Array.prototype.slice.call(document.querySelectorAll('buy-buttons'));
    if (formId) {
      groups = groups.filter(function (bb) { return bb.getAttribute('form') === formId; });
    }
    var banners = [];
    groups.forEach(function (bb) {
      bb.querySelectorAll(':scope > .banner--error').forEach(function (b) { banners.push(b); });
    });
    if (banners.length <= 1) return;                  // nothing to de-dupe
    var keep = null;
    if (lastSubmitBuyButtons && lastSubmitBuyButtons.isConnected) {
      for (var i = 0; i < banners.length; i++) {
        if (banners[i].parentElement === lastSubmitBuyButtons) { keep = banners[i]; break; }
      }
    }
    if (!keep) keep = banners[0];                     // fallback: keep the first (main) banner
    banners.forEach(function (b) { if (b !== keep) b.remove(); });
  });
})();
